import { CriteriaCatalog } from "./components/CriteriaCatalog";
import { CriteriaCreateEdit } from "./components/CriteriaCreateEdit";
import { CriteriaView } from "./components/CriteriaView";
import { Campaigns } from "./components/Campaigns";
import { CampaignCreate } from "./components/CampaignCreate";
import { Feedbacks } from "./components/Feedbacks";
import {FeedbackForm} from "./components/FeedbackForm";
import {FeedbackView} from "./components/FeedbackView";
import {Summary} from "./components/Summary";
import { Teams } from "./components/Teams";
import {TeamsView} from "./components/TeamsView";
import {TeamsCreateEdit} from "./components/TeamsCreateEdit";
import {RatingPrograms} from "./components/RatingPrograms";
import {RatingProgramCreate} from "./components/RatingProgramCreate";
import {SupplierCreateEdit} from "./components/SupplierCreateEdit";
import {SupplierMaintenance} from "./components/SupplierMaintenance";
import {SupplierView} from "./components/SupplierView";
import {Ratings} from "./components/Ratings";
import {HomeView} from "./components/HomeView";
import {Groups} from "./components/Groups";

const routes = [
    { path: "/criteria-catalog", name: "Criteria Catalog", Component: CriteriaCatalog, role: "" },
    { path: "/criteria-catalog/create-criteria", name: "Create Criteria", Component: CriteriaCreateEdit, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/criteria-catalog/edit-criteria/:criteriaId", name: "Edit Criteria", Component: CriteriaCreateEdit, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/criteria-catalog/view-criteria/:criteriaId", name: "View Criteria", Component: CriteriaView, role: "" },
    { path: "/campaigns", name: "Campaigns", Component: Campaigns, role: "" },
    { path: "/groups", name: "AE Group Maintenance", Component: Groups, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/rating-teams", name: "Rating Teams Maintenance", Component: Teams, role: "" },
    { path: "/rating-teams/view-team/:teamId", name: "Rating Team", Component: TeamsView, role: "" },
    { path: "/rating-teams/edit-team/:teamId", name: "Edit Rating Team", Component: TeamsCreateEdit, role: "" },
    { path: "/rating-teams/create-team", name: "Create Rating Team", Component: TeamsCreateEdit, role: "" },
    { path: "/campaigns/create-campaign", name: "Subjective Feedback Request", Component: CampaignCreate, role: "" },
    { path: "/campaigns/summary/:editCampaignId", name: "Subjective Feedback Request", Component: Summary, role: "" },
    { path: "/campaigns/edit-campaign/:editCampaignId", name: "Subjective Feedback Request", Component: CampaignCreate, role: "" },
    { path: "/feedback", name: "Feedback Requested Of Me", Component: Feedbacks, role: "ALL" },
    { path: "/feedback/submit-feedback/:editFeedbackId", name: "Feedback Requested Of Me", Component: FeedbackForm, role: "ALL" },
    { path: "/feedback/view-feedback/:editFeedbackId", name: "Feedback Requested Of Me", Component: FeedbackView, role: "ALL" },
    { path: "/rating-programs", name: "Rating Programs", Component: RatingPrograms, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/rating-programs/create-rating-program", name: "Create Annual AE Ratings", Component: RatingProgramCreate, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/rating-programs/edit-rating-program/:editRatingProgramId", name: "Create Annual AE Ratings", Component: RatingProgramCreate, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/supplier-mnt", name: "Supplier Maintenance", Component: SupplierMaintenance, role: "" },
    { path: "/supplier-mnt/create-ae-supplier", name: "Supplier Maintenance", Component: SupplierCreateEdit, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/supplier-mnt/edit-ae-supplier/:supplierNum", name: "Supplier Maintenance", Component: SupplierCreateEdit, role: "CRITERIA_CATALOG_ADMIN" },
    { path: "/supplier-mnt/view-ae-supplier/:supplierNum", name: "Supplier Maintenance", Component: SupplierView, role: "" },
    { path: "/ratings", name: "Ratings", Component: Ratings, role: "ALL" },
    { path: "/", name: "Home", Component: HomeView, role: "ALL" }
];

export default routes;
